import { getBetTitlePulseBetProps, getBetStatusLabelProps, getBonusDetailsListProps, getTotalReturnProps, getBetSummaryProps, isBonusAvailable } from "../bet";
import { getMarketNameProps, getEventDetailsProps } from "../selection";
export const getPulseBetProps = (bet, state) => {
    const props = {
        betTitle: getBetTitlePulseBetProps(bet, state),
        betStatusLabel: getBetStatusLabelProps(bet, state),
        marketName: getMarketNameProps(bet.selections[0]),
        totalReturn: getTotalReturnProps(bet, state),
        eventDetails: getEventDetailsProps(bet.type, bet.selections[0], state),
        betSummary: getBetSummaryProps(bet, state)
    };
    if (isBonusAvailable(bet)) {
        props.bonusDetailsList = getBonusDetailsListProps(bet, state);
    }
    return props;
};
//# sourceMappingURL=getPulseBetProps.js.map